import React from 'react';
import { FaConnectdevelop, FaCalendarAlt, FaUserGraduate, FaHandHoldingHeart } from 'react-icons/fa';
import RichText from '../ui/RichText';
import '../../css/common/AlumniCard.css';

const AlumniCard = ({ resource }) => {
  const getIcon = (iconType) => {
    switch (iconType) {
      case 'connect':
        return <FaConnectdevelop />;
      case 'events':
        return <FaCalendarAlt />;
      case 'mentor':
        return <FaUserGraduate />;
      case 'support':
        return <FaHandHoldingHeart />;
      default:
        return <FaConnectdevelop />;
    }
  };

  const handleClick = (e) => {
    if (resource.external) {
      e.preventDefault();
      window.open(resource.link, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className={`alumni-card ${resource.featured ? 'featured' : ''}`}>
      <div className="alumni-card-header">
        <div className="alumni-card-icon">
          {getIcon(resource.icon)}
        </div>
        <h3 className="alumni-card-title">{resource.title}</h3>
      </div>
      
      <RichText value={resource.description} className="alumni-card-description" />
      
      <a 
        href={resource.link} 
        className="alumni-card-link"
        onClick={handleClick}
        target={resource.external ? "_blank" : undefined}
        rel={resource.external ? "noopener noreferrer" : undefined}
      >
        {resource.linkText}
      </a>
    </div>
  );
};

export default AlumniCard; 